import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'

import {
    ContainerUsage,
} from '../../longTermLease.types'

const columns = ({
    l,
    containerLinkConfig,
}: {l: (l:string) => string,
    containerLinkConfig?: {
        path: string[],
        params: Record<string, string>,
    }
}): RichTableColumns<keyof ContainerUsage>[] => {
    return [
        {
            id: 'containerSerialNumber',
            headerProps: {
                children: l('Container.serialNumber'),
                sorting: false,
            },
            componentName: 'SkyNetTableLink',
            linkConfig: containerLinkConfig,
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
            mapCellProps: 'containerSerialNumber',
        },
        {
            id: 'containerJypId',
            headerProps: {
                children: l('Container.jypNumber'),
                sorting: false,
            },
            mapCellProps: 'containerJypId',
        },
        {
            id: 'containerContainerStatus',
            headerProps: {
                children: l('Container.containerStatusEnriched'),
                sorting: false,
            },
            componentName: 'ContainerStatus',
            mapCellProps: 'containerContainerStatus',
        },
        {
            id: 'containerContainerTypeContainerModel',
            headerProps: {
                children: l('ContainerType.containerModel'),
                sorting: false,
            },
            mapCellProps: 'containerContainerTypeContainerModel',
        },
        {
            id: 'orderNumbers',
            headerProps: {
                children: l('AvailableContainersView.currentOrderNumber'),
                sorting: false,
            },
            componentName: 'List',
            mapCellProps: 'orderNumbers',
        },
        {
            id: 'usageDuringSelectedPeriod',
            headerProps: {
                children: l('Container.usageDuringSelectedPeriod'),
                sorting: false,
            },
            mapCellProps: 'usageDuringSelectedPeriod',
            alignTextRight: true,
        },
    ]
}

export default columns
